import { reqServiceList } from '@/api/hail'

export default {
  async fetchServiceList({ commit }) {
    const { result } = await reqServiceList()
    commit('setServiceList', result.serviceList)
  },
}



// WEBPACK FOOTER //
// ./src/store/hail/actions.js